import { useEffect } from 'react';

import { getFulfillmentConfigurationError } from '@libs/shared-ui';

import { useProduct } from '@/entities/product';
import { clearErrors, setError, trigger, usePurchaseFormWatch } from '@/entities/purchase-form';

export const usePurchaseValidation = () => {
    const { product, tailored, isError } = useProduct();
    const selectedDeliveryMethod = usePurchaseFormWatch('fulfilmentMethod');

    const bopisStoreId = product?.sku && tailored?.variants?.[product.sku].BOPIS?.storeId;
    const sddValidationResult = product?.sku && tailored?.variants?.[product.sku].SDD?.doorDashValidationSuccess;

    useEffect(() => {
        clearErrors('root.deliveryMethods');

        if (isError || !product) return;

        if (selectedDeliveryMethod) {
            const configurationError = getFulfillmentConfigurationError({
                fulfillmentMethod: selectedDeliveryMethod,
                hasBopisStore: Boolean(bopisStoreId),
                hasSddValidation: Boolean(sddValidationResult),
            });

            if (configurationError) {
                const errorPath =
                    selectedDeliveryMethod === 'bopis' ? 'root.deliveryMethods.bopis' : 'root.deliveryMethods.sdd';
                setError(errorPath, { message: configurationError });
            } else if (selectedDeliveryMethod === 'bopis') {
                clearErrors('root.deliveryMethods.bopis');
            } else if (selectedDeliveryMethod === 'sdd') {
                clearErrors('root.deliveryMethods.sdd');
            }
        }

        void trigger('fulfilmentMethod');
    }, [bopisStoreId, sddValidationResult, selectedDeliveryMethod, isError, product]);
};
